/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_ViewsInputs */

const en_mk_mx_views = /** @type {(inputs: Mk_Mx_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved views & shared filters`)
};

const id_mk_mx_views = /** @type {(inputs: Mk_Mx_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan tersimpan & filter tim`)
};

/**
* | output |
* | --- |
* | "Saved views & shared filters" |
*
* @param {Mk_Mx_ViewsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_views = /** @type {((inputs?: Mk_Mx_ViewsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_ViewsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_views(inputs)
	return en_mk_mx_views(inputs)
});